import { _isNil } from '@/littledash';
import { ENTITY_LABELS } from '../EntityTabs';
import type { SyncConfigurationAuditChange } from '../SyncConfiguration.model';

export const AUDIT_ACTION_LABELS: Record<SyncConfigurationAuditChange['action'], string> = {
  CONFIG_UPDATED: 'Configuration updated',
  ENABLED: 'Switched to In Vivo configuration',
  DISABLED: 'Switched to Benchling Core configuration',
  IMPORT_COMMITTED: 'Configuration imported',
};

export const auditActionLabel = (action: SyncConfigurationAuditChange['action']): string =>
  AUDIT_ACTION_LABELS[action] ?? action;

/** The changed entity's label, or null for team-wide settings and search-schema assignments. */
export const auditEntityLabel = (entityType: SyncConfigurationAuditChange['entity_type']): string | null =>
  _isNil(entityType) ? null : (ENTITY_LABELS[entityType] ?? entityType);
